module.exports = __webpack_public_path__ + "static/media/coding-programming-language-svgrepo-com.192735af.svg";